<template>
    <span>
        <div>
            <!-- Begin:PageContent:Main -->
            <section id="content" class="image-bg2">
                <div class="container">
                    <div class="row">
                        <!-- Begin:Content-FlightSearchTabs-Booking -->
                        <div id="main" class="col-sm-8 col-md-9">
                            <sdr-shared-flightsearch-tabs modulo="booking"></sdr-shared-flightsearch-tabs>
                        </div>
                        <!-- Begin:Content-FlightSearchTabs-Booking -->


                        <!-- Begin:Content-SideBar-Booking -->
                        <div class="sidebar col-sm-4 col-md-3">
                            <sdr-covid19-box></sdr-covid19-box>
                            <sdr-contact-box></sdr-contact-box>
                            <sdr-importantinfos3-box></sdr-importantinfos3-box>
                        </div>
                        <!-- End:Content-SideBar-Booking -->
                    </div>
                </div>
            </section>
            <!-- End:PageContent:Main -->


            <!-- Begin:Content:KeyDestinations -->
            <sdr-keydestinations modulo="booking"></sdr-keydestinations>
            <!-- End:Content:KeyDestinations -->

            <!-- Begin:Content:FlightSearchResults -->
            <sdr-shared-flightsearchresults modulo="booking"></sdr-shared-flightsearchresults>
            <!-- End:Content:FlightSearchResults -->

            <!-- Begin:Content:FurtherServices -->
            <sdr-furtherserives></sdr-furtherserives>
            <!-- End:Content:FurtherServices -->

            <!-- Begin:PromoBox -->
            <sdr-promobox-sundair-app></sdr-promobox-sundair-app>
            <!-- End:PromoBox -->
        </div>
    </span>
</template>

<script>
    import FlightSearchTabs from '../shared/flightsearch/FlightSearchTabs.vue'; // Entire Tabs Construct (shared)
    import FlightSearchResults from '../shared/flightsearch/FlightSearchResults.vue'; // Content

    import ContactBox from '../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import Covid19Box from '../shared/sidebar/Covid19Box.vue'; // Sidebar (right)
    import ImportantInfos3Box from '../shared/sidebar/ImportantInfos3Box.vue'; // Sidebar (right)

    import KeyDestinations from '../booking/pagecontent/KeyDestinations.vue'; // Content
    import FurtherServices from '../booking/pagecontent/FurtherServices.vue'; // Content
    import PromoBoxSundairApp from '../booking/pagecontent/PromoBoxSundairApp.vue';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-flightsearch-tabs': FlightSearchTabs,
            'sdr-shared-flightsearchresults': FlightSearchResults,

            'sdr-contact-box': ContactBox,
            'sdr-covid19-box': Covid19Box,
            'sdr-importantinfos3-box': ImportantInfos3Box,

            'sdr-keydestinations': KeyDestinations,
            'sdr-furtherserives': FurtherServices,
            'sdr-promobox-sundair-app': PromoBoxSundairApp,

        }, // eo components{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .alert.alert-error {
        background: #e22a24;
        color: #ffffff;
        margin-left: 15px;
        margin-right: 15px;
        font-size: 15px;
    }
</style>
